import { CircularProgress, Grid } from "@mui/material"
import React, { useEffect, useState } from "react"
import Vista from "../../components/Vista"
import Servo from "../../services/servo"
import { useHistory } from "react-router-dom"
import { useMessages } from "../../hooks/useMessages"
import { useAlert } from "../../hooks/useAlert"
import Selector from "./Selector"
import CierreOrden, { estadosTerminados } from "./CierreOrden"
import DatosOrdenServicio from "./DatosOrdenServicio"
import Observacion from "./Observacion"
// import Diagnostico from "./Diagnostico"
import Refaccion from "./Refaccion"
import ManoObra from "./ManoObra"
import OtroTaller from "./OtroTaller"
import { useLocalStorage } from "../../hooks/useLocalStorage"
import { socketUrl } from "../../utils/variables"
import moment from "moment"
import OrdenCompraServicio from "./OrdenCompraServicio"
import Inspeccion from "./Inspeccion"
import "../zonda-redesign.css"

const Detail = ({ match }) => {
  const permisoCheck = "ordenServicios"
  const [permiso] = useLocalStorage("permiso", null)
  const [screen, setScreen] = useState("DatosOrdenServicio")
  const { showAlert } = useAlert()
  const id = match?.params?.id
  const editado = !!id
  const { setMessages } = useMessages()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [dataList, setDataList] = useState([])
  const user = JSON.parse(localStorage.getItem("user")) || {}
  const isMecanico = user?.permisos?.find((permiso) => permiso === "mecanico")

  const getDatos = async () => {
    setLoading(true)

    let res = await Servo.get(
      "orden-servicios" +
        "?idOrdenServicio=" +
        id +
        "&expand=checklists.datoschecklists.areas," +
        "checklists.datoschecklists.carros.empresa," +
        "checklists.datoschecklists.empresas," +
        "checklists.gasolinachecklists.notas," +
        "empresas," +
        "observaciones," +
        "manosObraOrdenServicio.manosObra," +
        "refacciones.productos," +
        "diagnosticos.productos.lote," +
        "otroTaller.archivos," +
        "ordenesCompra.ordenesCompraRefacciones.productos," +
        "ordenesCompra.ordenesCompraRefacciones.proveedores," +
        "inspecciones," +
        "creados"
    )
    if (
      res &&
      res.cuerpo &&
      res.cuerpo.resultado &&
      Array.isArray(res.cuerpo.resultado) &&
      res.cuerpo.resultado.length > 0
    ) {
      setformDetails(res?.cuerpo?.resultado[0])
      const orden = res.cuerpo.resultado[0]
      const empresaVehiculo = orden.checklists?.datoschecklists?.carros?.empresa
      setEmpresa(orden.empresas || empresaVehiculo || null)
      setChecklist({
        ...checklist,
        idChecklist: res?.cuerpo?.resultado[0]?.idChecklist,
        economico:
          res?.cuerpo?.resultado[0]?.checklists?.datoschecklists?.carros
            ?.economico,
        placas:
          res?.cuerpo?.resultado[0]?.checklists?.datoschecklists?.carros
            ?.placas,
        modelo:
          res?.cuerpo?.resultado[0]?.checklists?.datoschecklists?.carros
            ?.modelo,
        marca:
          res?.cuerpo?.resultado[0]?.checklists?.datoschecklists?.carros?.marca,
        year: res?.cuerpo?.resultado[0]?.checklists?.datoschecklists?.carros
          ?.year,
        vin: res?.cuerpo?.resultado[0]?.checklists?.datoschecklists?.carros
          ?.vin,
        fechaPoliza:
          res?.cuerpo?.resultado[0]?.checklists?.datoschecklists?.carros
            ?.fechaPoliza,
        tarjetaCirculacion:
          res?.cuerpo?.resultado[0]?.checklists?.datoschecklists?.carros
            ?.tarjetaCirculacion,
        nombreEmpresa: empresaVehiculo?.nombre || "",
        proyecto:
          res?.cuerpo?.resultado[0]?.checklists?.datoschecklists?.areas?.nombre,
        notas: res?.cuerpo?.resultado[0]?.checklists?.gasolinachecklists?.notas,
        kilometraje:
          res?.cuerpo?.resultado[0]?.checklists?.gasolinachecklists
            ?.kilometraje,
        gasolina:
          res?.cuerpo?.resultado[0]?.checklists?.gasolinachecklists?.gasolina
      })
      // setDiagnosticos(res?.cuerpo?.resultado[0]?.diagnosticos || [])
      setInspecciones(res?.cuerpo?.resultado[0]?.inspecciones || [])
      setOrdenesCompra(res?.cuerpo?.resultado[0]?.ordenesCompra || [])
      setObservaciones(res?.cuerpo?.resultado[0]?.observaciones || [])
      setManosObraOrdenServicio(
        res?.cuerpo?.resultado[0]?.manosObraOrdenServicio || []
      )
      const otroTallerData = res?.cuerpo?.resultado[0]?.otroTaller
      if (Array.isArray(otroTallerData)) {
        const archivosTotales = otroTallerData
          .map((taller) => taller.archivos || [])
          .flat()

        setFiles(archivosTotales)
      } else {
        setFiles([])
      }
      setRefaccionesGuardadas(res?.cuerpo?.resultado[0]?.refacciones)
    }
    setLoading(false)
  }

  const getUsers = async () => {
    try {
      const res = await Servo.get("usuarios")

      if (Array.isArray(res?.cuerpo?.resultado)) {
        setUsuariosDisponibles(res.cuerpo.resultado)
      }
    } catch (error) {
      console.error("Error al obtener usuarios:", error)
    }
  }

  const getChecklists = async () => {
    try {
      const res = await Servo.get(
        "checklists?expand=datoschecklists.carros,datoschecklists.empresas,datoschecklists.areas,gasolinachecklists.notas"
      )
      if (Array.isArray(res?.cuerpo?.resultado)) {
        setDataList(res.cuerpo.resultado) // Asegúrate de usar este estado en el modal
      }
    } catch (error) {
      console.error("Error al obtener los checklists:", error)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      if (editado) {
        await getDatos()
      } else {
        await getChecklists()

        setformDetails({
          fechaSolicitud: moment().format("YYYY-MM-DD"),
          aplicaDescuento: false,
          descuento: 0
        })
      }

      await getUsers()
    }

    fetchData()
  }, [editado])

  const validacionesToChange = () => {
    let dg = true

    if (!editado) {
      if (screen == "DatosOrdenServicio") {
        showAlert({
          message: "seleccionar un checklist, es requerido",
          severity: "warning"
        })
      }
      dg = false
    }

    if (isMecanico && screen === "OrdenCompraServ") {
      showAlert({
        message: "No tienes permisos para realizar una orden de compra",
        severity: "warning"
      })
      return { dg: false }
    }

    return { dg }
  }

  const [loadingButton, setLoadingButton] = useState(false)
  const [formDetails, setformDetails] = useState({})
  const [empresa, setEmpresa] = useState(null)
  const [checklist, setChecklist] = useState({})
  const [observaciones, setObservaciones] = useState([])
  const [inspecciones, setInspecciones] = useState([])
  const [manosObraOrdenServicio, setManosObraOrdenServicio] = useState([])
  // const [diagnosticos, setDiagnosticos] = useState([])
  const [ordenesCompra, setOrdenesCompra] = useState([])
  const [servicioOtroTaller, setServicioOtroTaller] = useState([])
  const [files, setFiles] = useState([])
  const [usuariosDisponibles, setUsuariosDisponibles] = useState([])
  const [refaccionesGuardadas, setRefaccionesGuardadas] = useState([])
  const [productosOrdenCompra, setProductosOrdenCompra] = useState([])
  const [mecanicosSeleccionados, setMecanicosSeleccionados] = useState({})

  const guardarDatosOrdenServicio = async () => {
    setLoadingButton(true)

    const aplica = !!formDetails?.aplicaDescuento
    const descuento = aplica ? Number(formDetails?.descuento || 0) : 0

    let body = {
      DatosOrdenServicio: {
        idEmpresa: empresa?.idEmpresa,
        idChecklist: checklist?.idChecklist,
        fechaSolicitud: formDetails?.fechaSolicitud,
        aplicaDescuento: aplica,
        descuento: descuento
      }
    }

    if (editado) {
      body.DatosOrdenServicio.idOrdenServicio = id
    }

    console.log("formDetails:", formDetails)
    console.log("Payload a enviar:", body)

    let res = await Servo.post(
      "orden-servicios/guardar-datos-orden-servicio",
      body,
      "ordenServicios",
      true,
      history
    )

    if (res?.cuerpo) {
      setMessages(res?.cuerpo)
      if (res?.cuerpo?.detalle?.estatus === 200) {
        fetch(socketUrl + "/noti", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            title: editado
              ? "SE MODIFICO UNA ORDEN DE SERVICIO"
              : "NUEVA ORDEN DE SERVICIO",
            id: res?.cuerpo?.detalle?.id,
            date: moment().format("DD/MM/YYYY"),
            time: moment().format("HH:mm")
          })
        })
      }
    }

    setLoadingButton(false)
  }

  const guardarObservacion = async () => {
    setLoadingButton(true)

    let body = {
      observacion: observaciones.map((obs) => obs.observacion)
    }

    if (editado) {
      body = { ...body, idOrdenServicio: id }
    }

    let res = await Servo.post(
      "orden-servicios/guardar-observaciones",
      body,
      "ordenServicios",
      false,
      history
    )

    if (res?.cuerpo) {
      setMessages(res?.cuerpo)

      if (res?.cuerpo?.detalle?.estatus === 200) {
        fetch(socketUrl + "/noti", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            title: editado
              ? "SE MODIFICO UNA ORDEN DE SERVICIO"
              : "NUEVA ORDEN DE SERVICIO",
            id: res?.cuerpo?.detalle?.id,
            date: moment().format("DD/MM/YYYY"),
            time: moment().format("HH:mm")
          })
        })
      }
    }

    setLoadingButton(false)
  }

  const guardarInspeccion = async () => {
    setLoadingButton(true)

    let body = {
      inspeccion: inspecciones.map((ins) => ins.inspeccion)
    }

    if (editado) {
      body = { ...body, idOrdenServicio: id }
    }

    let res = await Servo.post(
      "orden-servicios/guardar-inspecciones",
      body,
      "ordenServicios",
      false,
      history
    )

    if (res?.cuerpo) {
      setMessages(res?.cuerpo)

      if (res?.cuerpo?.detalle?.estatus === 200) {
        fetch(socketUrl + "/noti", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            title: editado
              ? "SE MODIFICO UNA ORDEN DE SERVICIO"
              : "NUEVA ORDEN DE SERVICIO",
            id: res?.cuerpo?.detalle?.id,
            date: moment().format("DD/MM/YYYY"),
            time: moment().format("HH:mm")
          })
        })
      }
    }

    setLoadingButton(false)
  }

  // const guardarDiagnostico = async () => {
  //   setLoadingButton(true)

  //   // Transformar diagnosticos para incluir 'refaccion'
  //   const diagnosticosConRefaccion = diagnosticos.map((diagnostico) => ({
  //     ...diagnostico,
  //     refaccion:
  //       diagnostico.nombreProducto ||
  //       diagnostico.producto?.nombreProducto ||
  //       diagnostico.refaccion
  //   }))

  //   let body = {
  //     diagnostico: diagnosticosConRefaccion
  //   }

  //   if (editado) {
  //     body = { ...body, idOrdenServicio: id }
  //   }

  //   try {
  //     let res = await Servo.post(
  //       "orden-servicios/guardar-diagnostico",
  //       body,
  //       "ordenServicios"
  //     )

  //     if (res?.cuerpo?.detalle?.estatus === 200) {
  //       setMessages({
  //         mensaje: "Diagnóstico guardado con éxito",
  //         color: "success",
  //         detalle: { estatus: 200 }
  //       })
  //     } else {
  //       setMessages({
  //         mensaje: "Error al guardar el diagnóstico",
  //         color: "error",
  //         detalle: { estatus: res?.cuerpo?.detalle?.estatus || 400 },
  //         errores: res?.cuerpo?.errores || null
  //       })
  //     }
  //   } catch (error) {
  //     setMessages({
  //       mensaje: "Error de conexión al guardar diagnóstico",
  //       color: "error",
  //       detalle: { estatus: 500 }
  //     })
  //   } finally {
  //     setLoadingButton(false)
  //   }
  // }

  const guardarManosObra = async (
    manosObraOrdenServicio,
    mecanicosSeleccionados
  ) => {
    setLoadingButton(true)

    let body = {
      manosObraOrdenServicio: manosObraOrdenServicio.map((mano) => ({
        ...mano,
        mecanicoCargo: mecanicosSeleccionados[mano.idManoObra] || ""
      }))
    }

    if (editado) {
      body = { ...body, idOrdenServicio: id }
    }

    let res = await Servo.post(
      "orden-servicios/guardar-manos-obra",
      body,
      "ordenServicios",
      false,
      history
    )

    if (res?.cuerpo) {
      setMessages(res?.cuerpo)

      if (res?.cuerpo?.detalle?.estatus === 200) {
        fetch(socketUrl + "/noti", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            title: editado
              ? "SE MODIFICO UNA ORDEN DE SERVICIO"
              : "NUEVA ORDEN DE SERVICIO",
            id: res?.cuerpo?.detalle?.id,
            date: moment().format("DD/MM/YYYY"),
            time: moment().format("HH:mm")
          })
        })
      }
    }

    setLoadingButton(false)
  }

  const guardarOrdenCompra = async (ordenesCompra) => {
    setLoadingButton(true)

    // Verifica que todos los productos tengan un proveedor asignado
    const ordenCompraConProveedores = ordenesCompra.map((producto) => {
      if (!producto.proveedor) {
        showAlert({
          message: "Todos los productos deben tener un proveedor asignado.",
          severity: "warning"
        })
        return null
      }
      return producto
    })

    // Si hay algún producto sin proveedor, no continuamos con la solicitud
    if (ordenCompraConProveedores.some((producto) => producto === null)) {
      setLoadingButton(false)
      return
    }

    let body = {
      ordenesCompra: ordenCompraConProveedores
    }

    if (editado) {
      body = { ...body, idOrdenServicio: id }
    }

    try {
      let res = await Servo.post(
        "orden-servicios/guardar-orden-compra",
        body,
        "ordenServicios",
        false,
        history
      )

      if (res?.cuerpo?.detalle?.estatus === 200) {
        setMessages(res?.cuerpo)
        setProductosOrdenCompra([])
        await getDatos()
        showAlert({
          message: "Orden de compra guardada correctamente",
          severity: "success"
        })
      } else {
        showAlert({
          message: res?.cuerpo?.mensaje || "No se pudo guardar la orden de compra",
          severity: "error"
        })
      }
    } catch (error) {
      showAlert({
        message: "No fue posible guardar la orden de compra",
        severity: "error"
      })
    } finally {
      setLoadingButton(false)
    }
  }

  const guardarOtroTaller = async (archivos) => {
    setLoadingButton(true)
    let body = {
      archivos: archivos
    }

    if (editado) {
      body = { ...body, idOrdenServicio: id }
    }

    let res = await Servo.post(
      "orden-servicios/guardar-otro-taller",
      body,
      "ordenServicios",
      true,
      history
    )
    if (res?.cuerpo) {
      setMessages(res?.cuerpo)
    }
    setLoadingButton(false)
  }

  return (
    <Vista style={{ display: "block", backgroundColor: "#FFFFFF" }}>
      {!loading ? (
        <main className="service-detail">
          <header className="service-detail__header">
            <div>
              <p className="service-page__eyebrow">Flujo de mantenimiento</p>
              <h1>{editado ? "Detalle de orden de servicio" : "Nueva orden de servicio"}</h1>
              <p>Completa cada sección para mantener actualizada la atención de la unidad.</p>
            </div>
            {editado && <span className="service-detail__number">OS · {id}</span>}
          </header>
          <div className="service-detail__nav">
            <Selector
              toChange={validacionesToChange}
              setScreen={setScreen}
              screen={screen}
              rolUsuario={permiso?.rol}
            />
          </div>
          {screen === "CierreOrden" ? <CierreOrden key={formDetails.idOrdenServicio} orden={formDetails} permiso={permiso} onSaved={getDatos} /> : <fieldset className="service-detail__readonly" disabled={estadosTerminados.includes(formDetails.status)}>
          {screen === "DatosOrdenServicio" ? (
            <DatosOrdenServicio
              formDetails={formDetails}
              setformDetails={setformDetails}
              empresa={empresa}
              setEmpresa={setEmpresa}
              checklist={checklist}
              setChecklist={setChecklist}
              guardarDatosOrdenServicio={guardarDatosOrdenServicio}
              loadingButton={loadingButton}
            />
          ) : screen === "Observacion" ? (
            <Observacion
              guardarObservacion={guardarObservacion}
              observaciones={observaciones}
              setObservaciones={setObservaciones}
            />
          ) : // : screen === "Diagnostico" ? (
          //   <Diagnostico
          //     diagnosticos={diagnosticos}
          //     setDiagnosticos={setDiagnosticos}
          //     guardarDiagnostico={guardarDiagnostico}
          //     ordenesCompra={ordenesCompra}
          //     setOrdenesCompra={setOrdenesCompra}
          //     guardarOrdenCompra={guardarOrdenCompra}
          //   />
          // )
          screen === "OrdenCompraServ" ? (
            <OrdenCompraServicio
              idOrdenServicio={id}
              guardarOrdenCompra={guardarOrdenCompra}
              ordenesCompra={ordenesCompra}
              setOrdenesCompra={setOrdenesCompra}
              productosOrdenCompra={productosOrdenCompra}
              setProductosOrdenCompra={setProductosOrdenCompra}
              loadingButton={loadingButton}
            />
          ) : screen === "OtroTaller" ? (
            <OtroTaller
              servicioOtroTaller={servicioOtroTaller}
              setServicioOtroTaller={setServicioOtroTaller}
              guardarOtroTaller={guardarOtroTaller}
              files={files}
              setFiles={setFiles}
            />
          ) : screen === "ManoObra" ? (
            <ManoObra
              idOrdenServicio={id}
              reloadRefacciones={getDatos}
              manosObraOrdenServicio={manosObraOrdenServicio}
              setManosObraOrdenServicio={setManosObraOrdenServicio}
              guardarManosObra={guardarManosObra}
              mecanicosSeleccionados={mecanicosSeleccionados}
              setMecanicosSeleccionados={setMecanicosSeleccionados}
              usuariosDisponibles={usuariosDisponibles}
            />
          ) : screen === "Refaccion" ? (
            <Refaccion
              refaccionesGuardadas={refaccionesGuardadas}
              empresa={empresa}
              setEmpresa={setEmpresa}
              id={id}
              reloadRefacciones={getDatos}
              setProductosOrdenCompra={setProductosOrdenCompra}
              irAOrdenCompra={() => setScreen("OrdenCompraServ")}
            />
          ) : screen === "Inspeccion" ? (
            <Inspeccion
              inspecciones={inspecciones}
              setInspecciones={setInspecciones}
              guardarInspeccion={guardarInspeccion}
              loadingButton={loadingButton}
            />
          ) : (
            ""
          )}
          </fieldset>}
        </main>
      ) : (
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            "@media (min-width: 600px)": {
              margin: "100px"
            }
          }}
        >
          <CircularProgress />
        </Grid>
      )}
    </Vista>
  )
}

export default Detail
